<mat-form-field>
<mat-label>Selecione os pallets desejados</mat-label>
<mat-select multiple>
<mat-option *ngFor="let pallet of pallets" [value]="pallet">
{{ handleName(pallet) + ', posição: ' + handlePosition(pallet.x, pallet.y) + ', quantidade: ' + handleQuantity(pallet.skuGroups)}}
</mat-option>
</mat-select>
</mat-form-field>
